import { Column, Table } from "../../../lib_react_adminlte/componentes/Table";
import LabeledInput from "../../../lib_react_adminlte/componentes/LabeledInput.jsx";
import ApiceComboEditPanel from "../../../lib_react_adminlte/componentes/ApiceComboEditPanel.jsx";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Cadastro from "../../../componentes/Cadastro";
import Api from "../../../utils/Api";
import "./tyle.css";
import { RadioButton } from "../../../lib_react_adminlte/componentes/RadioGroup.jsx";
import Button from "../../../lib_react_adminlte/componentes/Button.jsx";

import constants from "../../../utils/constants";

const codigo_tela = "008";

// função principal
function Usuario({ usuario, empresa }) {
  const camposObrigatorios = [
    "nome_usuario",
    "login",
    "telefone",
    "tipo_usuario",
  ];
  // state da tela
  const [nome_usuario, setNome_usuario] = useState("");
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmar_senha, setConfirmar_senha] = useState("");
  const [email, setEmail] = useState("");
  const [id_pk, setId_pk] = useState("");
  const [empresaNova, setEmpresaNova] = useState("");
  const [tipo_usuario, setTipo_usuario] = useState("");
  const [id_usuario, setId_usuario] = useState();
  const [empresas, setEmpresas] = useState([]);
  const [telefone, setTelefone] = useState("");
  const [empresa_combo, setEmpresaCombo] = useState("");

  const [empresasOrigem, setEmpresasOrigem] = useState([]);

  const empresaCombo = useRef({});

  const [itemSelecionado, setItemSelecionado] = useState([]);
  // declaração da referencia que será utilizada logo abaixo
  const cadastroRef = useRef({});

  // função que executa sempre que entramos na tela, ou se colocarmos entre [] uma variável, ele vai executar o useEffect sempre que existir uma alteração nessa variável.
  useEffect(() => {
    setId_usuario(usuario.id_pk);
  }, []);

  // renderizando as colunas
  function renderColunas() {
    return [
      <Column key={1} style={{ width: "10%" }} field="id_pk" header="ID" />,
      <Column
        key={2}
        style={{ width: "50%" }}
        field="nome_usuario"
        header="Nome Usuário"
      />,
      <Column key={3} style={{ width: "40%" }} field="login" header="Login" />,
      <Column key={4} style={{ width: "40%" }} field="email" header="Email" />,
      <Column
        key={5}
        style={{ width: "40%" }}
        field="tipo_usuario"
        header="Tipo Usuário"
      />,
    ];
  }

  // função que retorna os registros
  async function getRegistros(filtro) {
    const ret = await Api.buscar("tab_usuario", filtro, "");
    return ret;
  }

  // function getMultiSelectValue(lista, chave) {
  //   let value = "";
  //   if (lista && lista.length > 0) {
  //     for (let i = 0; i < lista.length; i++) {
  //       if (i + 1 === lista.length) {
  //         value += lista[i][chave];
  //       } else {
  //         // value += lista[i][chave] + ', ';
  //         value += lista[i][chave] + ", ";
  //       }
  //     }
  //   }
  //   return value;
  // }

  // create a function that delet an item of index in the empresas list
  function deleteItem(valor, item, index) {
    const list = [...empresas];
    list.splice(index, 1);
    setEmpresas(list);
  }

  // renderiza o formulário da tela
  function renderForm() {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-sm-4">
            <LabeledInput
              label="Nome (*):"
              placeholder="Nome"
              uppercase="false"
              value={nome_usuario}
              onChange={(e) => {
                setNome_usuario(e.target.value);
              }}
            />
          </div>
          <div className="col-sm-4">
            <LabeledInput
              label="Email:"
              placeholder="Email"
              uppercase="false"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <div className="col-sm-4">
            <LabeledInput
              label="Telefone (*):"
              placeholder="Telefone"
              uppercase="false"
              value={telefone}
              onChange={(e) => {
                setTelefone(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="row mt-5" style={{ marginTop: "10px" }}>
          <div className="col-sm-4">
            <div
              className="bordaTransparente fontTela"
              style={{ width: "100%", height: "100%" }}
            >
              <label style={{ padding: "5px" }}>TIPO USUÁRIO (*) </label>
              <div
                style={{
                  display: "flex",
                  marginTop: "-15px",
                  marginLeft: "3px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <RadioButton
                    id={2}
                    checked={tipo_usuario === 2}
                    text="Proprietário"
                    onChange={() => setTipo_usuario(2)}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "-15px",
                  marginLeft: "3px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <RadioButton
                    id={3}
                    checked={tipo_usuario === 3}
                    text="Financeiro CR/CP"
                    onChange={() => setTipo_usuario(3)}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "-15px",
                  marginLeft: "3px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <RadioButton
                    id={4}
                    checked={tipo_usuario === 4}
                    text="Vendas"
                    onChange={() => setTipo_usuario(4)}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "-15px",
                  marginLeft: "3px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <RadioButton
                    id={5}
                    checked={tipo_usuario === 5}
                    text="Vendas + CR"
                    onChange={() => setTipo_usuario(5)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-2">
            <LabeledInput
              label="Login:"
              placeholder="Login"
              value={login}
              onChange={(e) => {
                setLogin(e.target.value.toUpperCase());
              }}
            />
          </div>

          {usuario.tipo_usuario == constants.tipo_usuario_admin && (
            <div>
              <div className="col-sm-2">
                <LabeledInput
                  label="Senha:"
                  placeholder="Senha"
                  type="password"
                  value={senha}
                  uppercase="false"
                  onChange={(e) => {
                    setSenha(e.target.value);
                  }}
                />
              </div>
              <div className="col-sm-2">
                <LabeledInput
                  label="Confirme a senha:"
                  placeholder="Senha"
                  type="password"
                  uppercase="false"
                  value={confirmar_senha}
                  onChange={(e) => {
                    setConfirmar_senha(e.target.value);
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <div style={{ paddingTop: "10px" }}>
          <div style={{ display: "flex" }}>
            <h4>Empresas:</h4>
            <Button
              icon="fa-plus"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                console.log("clicou no botao");
                empresaCombo.current.modal.show();
              }}
            />
          </div>
        </div>

        <ApiceComboEditPanel
          chave="id_pk"
          ref={empresaCombo}
          tabela="tab_empresa"
          desc="nome_fantasia"
          escondeInput
          escondeLupa
          escondeDescricao
          pagination
          retornaObjeto
          btnClass="btn-blue"
          tableMaxHeight={"400px"}
          value={empresa_combo}
          api={Api}
          colunas={[
            <Column
              key={0}
              style={{ width: "75%" }}
              field="nome_fantasia"
              header="Nome"
            />,
            <Column
              key={1}
              style={{ width: "25%" }}
              field="doc_federal"
              header="CPF/CNPJ"
            />,
          ]}
          onChange={(e) => {
            const novaEmpresa = e.target.value;
            const empresaExistente = empresas.some(
              (empresa) => empresa.id_pk === novaEmpresa.id_pk
            );

            setEmpresaCombo(novaEmpresa.id_pk);

            if (!empresaExistente) {
              const novaListaEmpresas = [...empresas, novaEmpresa];
              setEmpresas(novaListaEmpresas);
            }
          }}
        />

        <div className="row">
          <div className="col-sm-12">
            <Table
              hideActions={false}
              className="tabelaMed"
              style={{ width: "100%" }}
              maxHeight={"calc(100vh - 400px)"}
              //onActionClick={this.onActionClick.bind(this)}
              onActionClick={deleteItem}
              selectable
              orderOnClick
              actions={[
                {
                  icone: "fa-trash",
                  id: "deletar-produto",
                  className: "btn-danger",
                  tipo: Table.ACAO_TABELA,
                },
              ]}
              data={empresas || []}
            >
              <Column
                style={{ width: "15%" }}
                key={1}
                field="doc_federal"
                header="Doc.Federal"
              />
              <Column
                style={{ width: "40%" }}
                key={2}
                field="nome_fantasia"
                header="Nome Fantazia"
              />
              <Column
                style={{ width: "45%" }}
                key={3}
                field="razao_social"
                header="Razão Social"
              />
            </Table>
          </div>
        </div>

        <div>
          <p>Campos marcados com (*) são obrigatórios.</p>
        </div>
      </div>
    );
  }

  //retorna a mensagem de excluir
  function getMsgExcluir() {
    return "Tem certeza que deseja excluir " + nome_usuario + " ?";
  }

  // function confirmarSenha() {
  //   if (senha.length < 6) {
  //     setMsgSenha("A senha deve ter no mínimo 6 caracteres");
  //     return false;
  //   } else if (senha !== confirmar_senha) {
  //     setMsgSenha("As senhas não conferem");
  //     return false;
  //   } else {
  //     setMsgSenha("");
  //     return true;
  //   }
  // }

  //
  function getRegistro() {
    return {
      cod_modal: codigo_tela,
      empresa: empresa.cod_empresa_usuario,
      nome_usuario: nome_usuario,
      login: login,
      senha: senha,
      confirmar_senha: confirmar_senha,
      email: email,
      empresaNova: empresaNova,
      empresas: empresas,
      tipo_usuario: tipo_usuario,
      id_usuario: id_usuario,
      id_pk: id_pk,
      empresa_selecionada: empresa,
      id_usuario_exclusao: usuario.id_pk,
      telefone: telefone,
      empresasOrigem: empresasOrigem,
    };
  }

  function setRegistro(item) {
    setNome_usuario(item.nome_usuario);
    setLogin(item.login);
    setSenha(item.senha);
    setConfirmar_senha(item.confirmar_senha);
    setEmail(item.email);
    setEmpresaNova(item.empresaNova);
    setEmpresas(item.empresas);
    setTipo_usuario(item.tipo_usuario);
    setId_pk(item.id_pk);
    setTelefone(item.telefone);
    setEmpresasOrigem(item.empresas);
  }

  function limparRegistro() {
    setNome_usuario("");
    setLogin("");
    setSenha("");
    setConfirmar_senha("");
    setEmail("");
    setEmpresaNova("");
    setEmpresas([]);
    setTelefone("");
    setTipo_usuario("");
    setId_pk("");
    setEmpresasOrigem([]);
  }

  function limpaSenha() {
    setSenha("");
    setConfirmar_senha("");
  }

  return (
    <div>
      <Cadastro
        tabela="tab_usuario"
        pk="id_pk"
        titulo="Cadastro de Usuário"
        renderForm={renderForm}
        renderColunas={renderColunas}
        getMsgExcluir={getMsgExcluir}
        getRegistros={getRegistros}
        getRegistro={getRegistro}
        setRegistro={setRegistro}
        limparRegistro={limparRegistro}
        onDoubleClick={itemSelecionado}
        itemSelecionadoTable={itemSelecionado}
        onSelecionarItemTable={(e) => setItemSelecionado(e)}
        ref={cadastroRef}
        limpaSenha={limpaSenha}
        codigo_tela={codigo_tela}
        camposObrigatorios={camposObrigatorios}
        tableSelecionavel
      />
    </div>
  );
}

export default connect((state) => ({
  usuario: state.usuario,
  empresa: state.empresa,
}))(Usuario);



// WEBPACK FOOTER //
// ./src/telas/Cadastros/Usuario/index.jsx